import type { DealerOptionDto, FactoryOptionDto } from '@api/machines'
import { customToast } from '@components/reusable'
import { nonEditableStatuses } from '../constants'
import { QuoteStatus } from '../enums'

export const calculateSectionTotal = (items: FactoryOptionDto[]) => {
  return items
    .filter(item => !item.isArchived)
    .map(item => item.dnp ?? 0)
    .reduce((acc, currentVal) => acc + currentVal, 0)
}

export const isQuoteAlreadyApprovedOrRejected = (quoteStatus: QuoteStatus) => {
  const isApproved =
    quoteStatus === QuoteStatus.DRAFT_ACCEPTED_BY_CUSTOMER ||
    quoteStatus === QuoteStatus.DRAFT_ACCEPTED_ON_BEHALF_OF_CUSTOMER ||
    // quoteStatus === QuoteStatus.PENDING_LEVEL_1_APPROVAL ||
    // quoteStatus === QuoteStatus.PENDING_LEVEL_2_APPROVAL ||
    quoteStatus === QuoteStatus.LEVEL_1_APPROVED_PENDING_LEVEL_2_APPROVAL ||
    quoteStatus === QuoteStatus.ACCEPTED

  const isRejected = quoteStatus === QuoteStatus.DRAFT_REJECTED_BY_CUSTOMER

  return isApproved || isRejected
}

export const getIsNonEditableQuote = (quoteStatus?: string | null) => {
  if (!quoteStatus) {
    return false
  }
  return nonEditableStatuses.includes(quoteStatus as QuoteStatus)
}

export const errorCustomToast = (title: string, subtitle: string) => {
  customToast({
    title: title,
    message: subtitle,
    severity: 'error',
    autoHideDuration: 300000,
    closableToast: true,
    sx: {
      width: '350px !important'
    }
  })
}

export const extractEqFamiliesAndGroups = (
  factoryFits: FactoryOptionDto[],
  dealerFits: DealerOptionDto[]
) => {
  const factoryFitsSet = new Set<string>()
  const dealerFitsSet = new Set<string>()

  for (const item of factoryFits) {
    // its a family
    if (
      (item.family || item.family !== '') &&
      (!item.group || item.group === '')
    ) {
      factoryFitsSet.add(String(item.family))
    }

    // its a group
    if (
      (item.group || item.group !== '') &&
      (!item.family || item.family === '')
    ) {
      factoryFitsSet.add(String(item.group))
    }
  }

  for (const item of dealerFits) {
    // its a family
    if (
      (item.family || item.family !== '') &&
      (!item.group || item.group === '')
    ) {
      dealerFitsSet.add(String(item.family))
    }

    // its a group
    if (
      (item.group || item.group !== '') &&
      (!item.family || item.family === '')
    ) {
      dealerFitsSet.add(String(item.group))
    }
  }

  return {
    factoryFits: [...Array.from(factoryFitsSet), 'Custom'],
    dealerFits: [...Array.from(dealerFitsSet), 'Custom']
  }
}
